import { render, staticRenderFns } from "./vendorAttachDetailAppr.vue?vue&type=template&id=7811f126"
import script from "./vendorAttachDetailAppr.vue?vue&type=script&lang=js"
export * from "./vendorAttachDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7811f126')) {
      api.createRecord('7811f126', component.options)
    } else {
      api.reload('7811f126', component.options)
    }
    module.hot.accept("./vendorAttachDetailAppr.vue?vue&type=template&id=7811f126", function () {
      api.rerender('7811f126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/csm/vendorAttachDetailAppr.vue"
export default component.exports